import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { withTenantContext } from "../../context_providers/TenantContext";

const SiteLogoImg = styled("img")`
  max-height: 150px;
  max-width: 300px;
`;

const SiteLogo = props => {
  const { t } = useTranslation();
  const altText = t("siteLogo.altText", { tenantName: props.tenant.name });
  return <SiteLogoImg src={props.src} alt={altText} />;
};

export default withTenantContext(SiteLogo);
